import Vue from 'vue'
import { usePluginInClient, registerComponent, registerComponentProgrammatic } from './utility'
import ModalLightBox from '~/components/common/Modal/ModalLightBox'
function open(propsData) {
  const ModalLightBoxComponent = Vue.extend(ModalLightBox)
  return new ModalLightBoxComponent({
    el: document.createElement('div'),
    propsData,
  })
}

const ModalLightBoxProgrammatic = {
  open(params) {
    const defaultParam = {
      medias: '',
      isCarousel: false,
    }
    const propsData = Object.assign(defaultParam, params)
    return open(propsData)
  },
}

const AcademyModalLightBox = {
  install(Vue) {
    registerComponent(Vue, ModalLightBox)
    registerComponentProgrammatic(Vue, 'lightbox', ModalLightBoxProgrammatic)
  },
}

usePluginInClient(AcademyModalLightBox)

export default AcademyModalLightBox
